import { ROLES, ROLE_VALUES, ROLE_OPTIONS } from '../../../lib/roles';
import { fetchTenants } from '../../tenants/Services/tenantsService';

// Versión simplificada de las columnas para el contexto multi-tenant del nuevo proyecto.
// El `tenantId` se inyecta automáticamente desde el contexto (subdominio / sesión),
// por lo que el form de creación/edición no lo muestra al usuario.

export const usersColumns = [
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
  },
  { id: 'nombre', label: 'Nombre', type: 'text', required: true, placeholder: 'Nombre completo' },
  {
    id: 'correo',
    label: 'Correo',
    type: 'email',
    required: true,
    placeholder: 'usuario@empresa.com',
  },
  {
    id: 'contrasena',
    label: 'Contraseña',
    type: 'password',
    required: true,
    onlyOnCreate: true,
    placeholder: 'Mínimo 6 caracteres',
  },
  {
    id: 'contrasena2',
    label: 'Repetir contraseña',
    type: 'password',
    required: true,
    onlyOnCreate: true,
    placeholder: 'Confirma la contraseña',
  },
  { id: 'cedula', label: 'Cédula / NIT', type: 'text', required: true, placeholder: '1234567890' },
  {
    id: 'rol',
    label: 'Rol',
    type: 'select',
    required: true,
    options: ROLE_OPTIONS,
  },
];

// En plataforma, además se puede elegir el tenant al que pertenecerá el user.
export const getUsersColumns = (ctx = {}) => {
  const inTenant = Boolean(ctx.tenant && ctx.tenant._id);
  if (inTenant) return usersColumns;
  return [
    ...usersColumns,
    {
      id: 'tenantId',
      label: 'Cliente operador (tenant)',
      type: 'select',
      required: true,
      // En el form real lo populamos con la lista de tenants al renderizar
      options: ctx.tenantOptions || [],
    },
  ];
};

export const columnsExcel = [
  { key: 'estado', header: 'Estado' },
  { key: 'nombre', header: 'Nombre' },
  { key: 'correo', header: 'Correo' },
  { key: 'cedula', header: 'Cédula / NIT' },
  { key: 'rol', header: 'Rol' },
  { key: 'tenantId', header: 'Tenant' },
];
